import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Loader2, Mail } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <Link to="/login" className="inline-flex items-center gap-1 text-sm font-semibold mb-6 hover:underline" data-testid="back-to-login">
          <ArrowLeft className="w-4 h-4" /> Back to Login
        </Link>

        <div className="brutalist-card p-8">
          {sent ? (
            <div className="text-center" data-testid="reset-sent-message">
              <div className="w-16 h-16 rounded-full bg-[#D6E6FA] border-2 border-[#0A0A0A] flex items-center justify-center mx-auto mb-5">
                <Mail className="w-8 h-8 text-[#3C8DE4]" />
              </div>
              <h1 className="text-2xl font-bold mb-3">Check Your Email</h1>
              <p className="text-sm text-[#4A4A4A] mb-6">
                If an account with <strong>{email}</strong> exists, we sent a password reset link. Check your inbox (and spam folder).
              </p>
              <Link to="/login" className="brutalist-btn-primary inline-block text-sm" data-testid="back-to-login-btn">
                Back to Login
              </Link>
            </div>
          ) : (
            <>
              <h1 className="text-2xl font-bold mb-2">Forgot Password</h1>
              <p className="text-sm text-[#4A4A4A] mb-6">Enter your email and we&apos;ll send you a link to reset your password.</p>

              {error && <div className="bg-red-50 border-2 border-red-300 rounded-lg p-3 mb-4 text-sm text-red-700" data-testid="forgot-error">{error}</div>}

              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <Label className="text-sm font-bold uppercase tracking-wider">Email</Label>
                  <Input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="your@email.com"
                    required
                    className="brutalist-input mt-1"
                    data-testid="forgot-email-input"
                  />
                </div>
                <button
                  type="submit"
                  disabled={loading}
                  className="brutalist-btn-primary w-full flex items-center justify-center gap-2"
                  data-testid="forgot-submit-btn"
                >
                  {loading ? <><Loader2 className="w-5 h-5 animate-spin" />Sending...</> : "Send Reset Link"}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
